module.exports = __webpack_public_path__ + "img/vars_logo_black.552e71e5.png";